const BLOCK_ELEMENTS = 'address,article,blockquote,div,li,p,section,tr';

const htmlToPlainText = (value?: unknown): string => {
  if (typeof value !== 'string') return String(value ?? '').trim();

  const documentNode = new DOMParser().parseFromString(value, 'text/html');
  documentNode.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
  documentNode.querySelectorAll(BLOCK_ELEMENTS).forEach(node => node.append('\n'));

  return (documentNode.body.textContent || '')
    .replace(/\u00a0/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n[ \t]+/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export default htmlToPlainText;
